module.exports = __webpack_public_path__ + "img/bg.10e6daad.png";